module.exports = __webpack_public_path__ + "img/Bluparadise_Valencia_Nuria_Daviu_WEB-006.0b6442db.jpg";